<div mat-dialog-title class="dialog-header d-flex justify-content-between">
    <div i18n="@@deleteDepartment">Delete Department</div>
    <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
    <div i18n="@@confirmDeleteDepartment" class="text-center dialog-sub-title mat-caption">Are you sure you want to delete this department?</div>
    <button i18n="@@delete" data-testid="delete_department_button"  class="w-100" mat-raised-button color="warn" (click)="deleteDepartment()">Delete</button>
</mat-dialog-content>